/**
 * Marca "esta aba está esperando um Pix", guardada no sessionStorage.
 *
 * O cliente sai para o app do banco e o celular muitas vezes recarrega a aba do
 * navegador na volta: sem a marca, a página esquecia o QR e voltava ao checkout, e o
 * cliente, sem ver a confirmação, pagava de novo. A marca sobrevive à recarga e diz ao
 * site inteiro para seguir perguntando se o pagamento entrou.
 */

export const CHAVE = "esperaPix";

/** O cliente costuma levar alguns minutos no app do banco; meia hora cobre com folga. */
export const VALIDADE_DA_ESPERA_MS = 30 * 60 * 1000;

export type TipoDeEspera = "assinatura" | "credits";

export interface Espera {
  tipo: TipoDeEspera;
  idioma: string;
  desde: number;
}

type Armazenamento = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function marcarEspera(
  armazenamento: Armazenamento,
  tipo: TipoDeEspera,
  idioma: string,
  agora: number = Date.now()
): void {
  try {
    armazenamento.setItem(CHAVE, JSON.stringify({ tipo, idioma, desde: agora }));
  } catch (_e) {
    // sem acesso (aba anônima do iOS): a espera vale só enquanto a página estiver aberta
  }
}

export function lerEspera(armazenamento: Armazenamento, agora: number = Date.now()): Espera | null {
  let guardado: string | null = null;
  try {
    guardado = armazenamento.getItem(CHAVE);
  } catch (_e) {
    return null;
  }
  if (!guardado) {
    return null;
  }

  let espera: any = null;
  try {
    espera = JSON.parse(guardado);
  } catch (_e) {
    espera = null;
  }

  const valida =
    espera &&
    (espera.tipo === "assinatura" || espera.tipo === "credits") &&
    typeof espera.idioma === "string" &&
    typeof espera.desde === "number" &&
    agora - espera.desde < VALIDADE_DA_ESPERA_MS;

  if (!valida) {
    limparEspera(armazenamento);
    return null;
  }

  return espera as Espera;
}

export function limparEspera(armazenamento: Armazenamento): void {
  try {
    armazenamento.removeItem(CHAVE);
  } catch (_e) {
    // sem acesso: a marca vence sozinha
  }
}

/** Crédito é outro pedido, em outra tabela, com a sua própria consulta. */
export function rotaDaConsulta(espera: Espera): string {
  return espera.tipo === "credits" ? "v1/assine/checkPixPaidCredists" : "v1/assine/checkPixPaid";
}

/** Página de confirmação de cada tipo; `pix=1` ajusta o texto de lá. */
export function destinoDaConfirmacao(espera: Espera) {
  return {
    name:
      espera.tipo === "credits"
        ? "language-assine-checkout-credits-success"
        : "language-assine-checkout-success",
    params: { language: espera.idioma },
    query: { pix: "1" },
  };
}
